import { CanvasSchema } from "@zapier/types";
import { z } from "zod";

// Response schemas
export const ZslAssetTypeSchema = z.enum([
  "zap",
  "interface",
  "table",
  // Add other asset types as needed
]);

export const ProposalSchema = z.object({
  source_node_id: z
    .string()
    .optional()
    .describe("The id of the node that this proposal is based on, if any"),
  interfaces: z
    .array(
      z.object({
        title: z.string().describe("The title of the asset"),
        downstream_prompt: z
          .string()
          .describe("The prompt for the downstream asset"),
      }),
    )
    .optional(),
  tables: z
    .array(
      z.object({
        title: z.string().describe("The title of the asset"),
        downstream_prompt: z
          .string()
          .describe("The prompt for the downstream asset"),
      }),
    )
    .optional(),
  zaps: z
    .array(
      z.object({
        title: z.string().describe("The title of the asset"),
        downstream_prompt: z
          .string()
          .describe("The prompt for the downstream asset"),
      }),
    )
    .optional(),
});

export const ZslGuessSchema = z.object({
  zaps: z.array(z.any()).optional(),
  interfaces: z.array(z.any()).optional(),
  tables: z.array(z.any()).optional(),
});

export const CanvasAdditionSchema = z.object({
  id: z.string(),
  proposal: ProposalSchema,
  outline: z.any().optional(),
  zsl: ZslGuessSchema.optional(),
});

export const EditCanvasResponseSchema = z.object({
  additions: z.array(CanvasAdditionSchema),
  removals: z.array(z.object({ id: z.string() })),
  changes: z.array(z.object({ id: z.string() })),
});

export type EditCanvasResponse = z.infer<typeof EditCanvasResponseSchema>;

// Request body schema
export const CanvasEditBodySchema = z.object({
  prompt: z.string().optional(),
  canvas: CanvasSchema,
  sourceNodeId: z.string().optional(),
  baseUrl: z.string().optional(),
});

export type CanvasEditBody = z.infer<typeof CanvasEditBodySchema>;

// Event handlers type
export interface RecommendationEventHandlers {
  onPartial?: (data: EditCanvasResponse) => void;
  onComplete?: (data: EditCanvasResponse) => void;
  onError?: (error: { error: string }) => void;
}
